import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { firstValueFrom } from "rxjs";

import {
  ButtonModule,
  DIALOG_DATA,
  DialogModule,
  DialogRef,
  DialogService,
} from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";

export type BvDeleteSendDialogParams = {
  confirmationKey: string;
};

@Component({
  templateUrl: "./bv-delete-send-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogModule, ButtonModule, I18nPipe],
  host: {
    class: "bv-delete-send-dialog-host",
  },
})
export class BvDeleteSendDialogComponent {
  constructor(
    private readonly dialogRef: DialogRef<boolean>,
    @Inject(DIALOG_DATA) protected readonly confirmationKey: string,
  ) {}

  protected close(result: boolean): void {
    void this.dialogRef.close(result);
  }

  static open(dialogService: DialogService, confirmationKey: string): Promise<boolean> {
    const dialogRef = dialogService.open<boolean>(BvDeleteSendDialogComponent, {
      data: confirmationKey,
    });
    return firstValueFrom(dialogRef.closed).then((result) => result ?? false);
  }
}
